module.exports = __webpack_public_path__ + "static/img/img2.558a42b8.png";